// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import mediaEntity from './entities/media.json';
import mediaMenu from '../pages/media/menu.json';
import mediaFullForm from '../pages/media/forms/full.json';
import mediaContextForm from '../pages/media/forms/context.json';
import mediaMiniForm from '../pages/media/forms/mini.json';
import mediaLookupForm from '../pages/media/forms/lookup.json';
import mediaTableView from '../pages/media/views/table.json';
import mediaStagesView from '../pages/media/views/stages.json';
import mediaCardsView from '../pages/media/views/cards.json';
import mediaInlineView from '../pages/media/views/inline.json';
import mediaBacklogView from '../pages/media/views/backlog.json';
import mediaSplitView from '../pages/media/views/split.json';
import mediaCalendarView from '../pages/media/views/calendar.json';
import mediaDashboardView from '../pages/media/views/dashboard.json';

/** Тип запису «Запит медіа» зі сторінками пакета: меню, форми та подання з pages/media/. */
export const mediaDefinition: IRecordTypeDefinition = {
  ...mediaEntity,
  views: assembleViewSet({
      table: mediaTableView,
      stages: mediaStagesView,
      cards: mediaCardsView,
      inline: mediaInlineView,
      backlog: mediaBacklogView,
      split: mediaSplitView,
      calendar: mediaCalendarView,
      dashboard: mediaDashboardView,
  }),
  form: mediaFullForm,
  forms: { full: mediaFullForm, context: mediaContextForm, mini: mediaMiniForm, lookup: mediaLookupForm },
  menu: mediaMenu,
} as IRecordTypeDefinition;
